import Util from "@/helper/Utility.js";
import ConfigManager from "@/config/ConfigManager.js";

export default {
    inject: ["AccountStore"],
    computed: {
        isInitial: function () {
            return this.AccountStore.state.isInitial;
        },
        isLogin: function () {
            return this.AccountStore.state.isLogin;
        },
        profile: function () {
            if (this.isLogin) {
                return this.AccountStore.state.profile;
            } else {
                return null;
            }
        },
        profileCustom: function () {
            if (this.isLogin) {
                return this.AccountStore.state.profileCustom;
            } else {
                return null;
            }
        },
        noti: function () {
            return this.AccountStore.state.noti;
        }
    },
    created: function () {
        this.AccountStore.methods.loginStatus().subscribe(() => {
            if (Util.isFunction(this.onAccountInit)) {
                this.onAccountInit();
            }
        });
    },
    methods: {
        checkLoginPopup: function (callbackFunction) {
            if (this.isLogin) { 
                callbackFunction();
            } else {
                if (this.alertModal != null) {
                    this.alertModal.clearModal()
                                                .setMsg("กรุณาลงทะเบียน S Plus+ ก่อนใช้งาน")
                                                .setBtnOk("เข้าสู่ระบบ")
                                                .show();
                    this.alertModal.onClickOk(()=> {
                        window.location.replace(ConfigManager.getWebSofinUrl());
                    });
                } else if (this.modalController.alertModal != null) { 
                    this.modalController.alertModal.clearModal()
                                                .setMsg("กรุณาลงทะเบียน S Plus+ ก่อนใช้งาน")
                                                .setBtnOk("เข้าสู่ระบบ")
                                                .show();
                    this.modalController.alertModal.onClickOk(()=> {
                        window.location.replace(ConfigManager.getWebSofinUrl());
                    });
                }
            }
        },
        updateNoti: function () {
            this.AccountStore.methods.getListNoti();
        }
    }
}
